var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-layout-dashboard"},[_c('dropdown-account',{staticClass:"dashboard-top-menu"}),_c('div',{staticClass:"d-flex d-flex-justify-between"},[_c('dashboard-sidebar'),_c('div',{staticClass:"main-content"},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }